/* eslint-disable @typescript-eslint/no-explicit-any */
import { Enum_Favorite_Type } from '@/graphql/generated/graphql';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useFavoriteStore } from '@/pages/favourites/store/useFavoriteStore';
import { addFavorite, existFavorite, findFavorite, removeFavorite } from '@/services/favorite/favorite.service';
import { useEffect, useState } from 'react';

export default function useFavorite({ relationId }: { relationId: string }) {
  const [exist, setExist] = useState<boolean>(false);
  const { authentication } = useAuthentication();
  const { removeFromFavourite, page, onInitPage } = useFavoriteStore();

  const handleClick = async (metadata: any, type?: Enum_Favorite_Type) => {
    try {
      if (exist) {
        const { data } = await findFavorite(relationId);
        if (!data?.favorites?.data[0]?.id) return console.error('Favorite not found');
        await removeFavorite(data?.favorites?.data[0]?.id || '');
        await removeFromFavourite(type || Enum_Favorite_Type.Podcast);
        setExist(false);
      } else {
        await addFavorite({
          metadata: JSON.stringify(metadata),
          relationId,
          type,
          user: authentication.user.id,
        });
        setExist(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    (async () => {
      await onInitPage();
    })();
  }, [onInitPage]);

  useEffect(() => {
    (async () => {
      if (!relationId) return;
      const { data } = await existFavorite(relationId);
      setExist((data?.favorites?.data?.length || 0) > 0);
    })();
  }, [relationId]);

  return { exist, page, handleClick };
}
